import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import TopBar from './global-components/topbar';
import ConstructionInfo01 from './section-components/construction-info1';

const Construction01 = () => {
    return <div>
        <TopBar/>
        <Navbar />
        {/* <PageHeader headertitle="House Constructions" subheader="Constructions" /> */}
        <ConstructionInfo01 />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Construction01
